class SibCollectionCarouselSlider {
  constructor() {
    this.init();
  }

  init() {
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper is not loaded');
      return;
    }

    const sliders = document.querySelectorAll('.sib-collection-carousel-slider__swiper');
    if (!sliders.length) return;

    sliders.forEach((slider) => {
      this.initSwiper(slider);
    });
  }

  initSwiper(slider) {
    const swiper = new Swiper(slider, {
      slidesPerView: 2,
      spaceBetween: 10,
      watchOverflow: true,
      loop: false,
      navigation: {
        nextEl: slider.parentElement.querySelector('.sib-collection-carousel-slider__navigation-next'),
        prevEl: slider.parentElement.querySelector('.sib-collection-carousel-slider__navigation-prev'),
      },
      breakpoints: {
        750: {
          slidesPerView: 3,
        },
        990: {
          slidesPerView: 4,
        },
        1300: {
          slidesPerView: 5,
        },
        1400: {
          slidesPerView: 6,
        },
        1500: {
          slidesPerView: 7,
        },
      },
      on: {
        init: function () {
          console.log('Swiper initialized');
        },
      },
    });
  }
}

if (typeof window !== 'undefined') {
  window.addEventListener('DOMContentLoaded', () => {
    new SibCollectionCarouselSlider();
  });
}
